import React from 'react';
import classNames from 'classnames';

import './container.scss';

interface ContainerProps {
  children?: any;
  extraClasses?: string;
}

const defaultProps: ContainerProps = {
  extraClasses: ''
};

const Container: React.SFC<ContainerProps> = props => (
  <div
    className={classNames(
      `o-wrapper o-wrapper--large c-container ${props.extraClasses}`
    )}
  >
    {props.children}
  </div>
);

Container.defaultProps = defaultProps;

export default Container;



// WEBPACK FOOTER //
// ./src/components/layout/container.tsx